import {createSelector} from 'reselect';
import {getSettings} from './selectors';

export default createSelector(
  [getSettings],
  settings => settings.show_message_pudo_not_available,
);
